// extracted by mini-css-extract-plugin
module.exports = {"organism__rich-text-section-container":"styles_organism__rich-text-section-container__DCMwp"};